
<template>
    <nav class="navigation">
        <div class="primary">
            <router-link :to="{ name: 'shoots' }" class="logo"><img src="/images/logo-simple.svg"/></router-link>

            <ul>
                <li style="font-size: .9rem"><a href="tel:+447776348278">CALL: <strong>07776 348 278</strong></a></li>
                <li v-if="auth.user && ( auth.user.superuser === true || auth.user.superuser === 1 )"><router-link :to="{ name: 'admin.shoots' }">Admin</router-link></li>
                <li v-if="auth.user"><a v-on:click="logout">Logout</a></li>
            </ul>
        </div>

        <a v-on:click="$root.toggleBasket" class="basket">
            <span>{{ basket ? basket.items.length : 0 }}</span>{{ $root.currency( basket ? basket.total : 0 ) }}
        </a>
    </nav>
</template>

<script>
    import auth from '../../support/Auth';
    import session from '../../support/Session';

	export default
    {
    	computed:
        {
            basket()
            {
                return this.session.basket;
            }
        },
    	data()
        {
        	return {
        		auth,
                session,
        	};
        },
        methods:
        {
            logout()
            {
                auth.logout().then( () => {
                	this.$router.push( { name: 'login' } );
                });
            },
        },
	};
</script>
